
































import StuntSheet from "@/models/StuntSheet";
import StuntSheetDot from "@/models/StuntSheetDot";
import { CalChartState } from "@/store";
import { Mutations } from "@/store/mutations";
import Vue from "vue";

export default Vue.extend({
  name: "SelectedDotEditor",
  computed: {
    dotsWithLabels(): [string, StuntSheetDot][] {
      const { show } = this.$store.state as CalChartState;
      const { selectedDotIds, selectedSS } = show;
      const dotsWithLabels = show.dotsWithLabelsForSS(selectedSS);
      return dotsWithLabels.filter(([, dot]) =>
        selectedDotIds.includes(dot.id)
      );
    },
    dotTypesOptions(): number[] {
      const stuntSheet: StuntSheet = this.$store.getters.getSelectedStuntSheet;
      return stuntSheet.dotTypes.map((_, index) => index);
    },
    label(): string | null {
      return this.dotsWithLabels.length === 1
        ? this.dotsWithLabels[0][0]
        : null;
    },
    dotTypeIndex: {
      get(): number | "" {
        if (this.dotsWithLabels.length === 1) {
          return this.dotsWithLabels[0][1].dotTypeIndex;
        } else {
          const firstDotTypeIndex = this.dotsWithLabels[0][1].dotTypeIndex;
          const singleDotType = this.dotsWithLabels.every(
            ([, dot]) => firstDotTypeIndex === dot.dotTypeIndex
          );
          return singleDotType ? firstDotTypeIndex : "";
        }
      },
      set(dotTypeIndex: number): void {
        this.$store.commit(
          Mutations.UPDATE_SELECTED_DOTS_DOT_TYPE,
          dotTypeIndex
        );
      },
    },
  },
});
